/**
 * Created by vladislav on 19.02.2020
 */

// eslint-disable-next-line
let KnockoutPlayerView = cc.Node.extend({
    ctor: function (player) {
        this._super();

        this.player = player;

        this.setAnchorPoint(0.5, 0.5);

        this.createAvatar();
        this.createBar();

        const styles = cleverapps.styles.KnockoutPlayerView.layout;
        const layout = new cleverapps.Layout([this.avatar, this.bar], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        this.addChild(layout);
        layout.setAlignment(styles);

        cleverapps.UI.wrap(this);
        this.onResize();

        if (cleverapps.config.debugMode) {
            this.clickRect = cc.rect(this.pos === "left" ? 0 : this.width / 2, 0, this.width / 2, this.height);

            cleverapps.UI.onClick(this, () => {
                if (cleverapps.forces.isRunningForce()) {
                    return;
                }

                if (Game.currentGame) {
                    Game.currentGame.discoverDebug(this.player);
                }
            });
        }
    },

    createAvatar: function () {
        const avatar = this.avatar = new cleverapps.UI.Avatar(this.player, {
            frame: this.player.frame
        });

        const frame = this.frame = new cleverapps.Spine(bundles.game.jsons.frame_pulsation_json);
        frame.setAnimation(0, "animation", true);
        avatar.addChild(this.frame);
        this.frame.setLocalZOrder(-1);
        this.frame.setVisible(false);
        this.frame.setAlignment(cleverapps.styles.KnockoutPlayerView.frame);
    },

    createBar: function () {
        const bar = this.bar = new ScaledProgressBar({
            progress: bundles.progress_bar.frames.bar_player_png,
            background: bundles.progress_bar.frames.bg_player_png,
            barText: {
                font: cleverapps.styles.FONTS.KNOCKOUT_BAR_TEXT
            }
        });

        bar.setGoal(Game.currentGame.totalItemsToSolve());
        bar.setLength(this.avatar.width);
        bar.setPercentage(this.player.amount / Game.currentGame.totalItemsToSolve());
    },

    updateProgress: function () {
        this.bar.setPercentage(this.player.amount, {
            animated: true
        });
    },

    runUserBehindAnimation: function () {
        if (this.userBehindRunning) {
            return;
        }
        if (cleverapps.forces.isRunningForce()) {
            return;
        }

        this.userBehindRunning = true;

        this._runFrameAnimation();
    },

    onResize: function () {
        this.setScale(cleverapps.styles.KnockoutPlayerView.scale[cleverapps.resolution.mode]);
    },

    _runFrameAnimation: function () {
        if (!this.frame) {
            return;
        }

        if (!this.userBehindRunning) {
            this.frame.setVisible(false);
            return;
        }

        this.frame.setVisible(true);
    },

    stopUserBehindAnimation: function () {
        this.userBehindRunning = false;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    KNOCKOUT_BAR_TEXT: {
        name: "default",
        size: 32,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.KnockoutPlayerView = {
    frame: {
        x: { align: "center" },
        y: { align: "center", dy: 2 }
    },

    layout: {
        x: { align: "center" },
        y: { align: "center" },
        margin: 10
    },

    scale: [0.7, 0.9, 1]
};